module.exports = __WEBPACK_EXTERNAL_MODULE_5__;


//////////////////
// WEBPACK FOOTER
// external {"root":"mobx","commonjs2":"mobx","commonjs":"mobx","amd":"mobx"}
// module id = 5
// module chunks = 0